import { useSyncExternalStore } from "react";

/**
 * Tiny shared store between useLogToolUsage (which knows whether a live
 * calculator or converter has a result, and how to charge a use) and
 * ToolContainer (which shows the "Copy result / Print / Save" bar).
 */
export interface ResultGateState {
  active: boolean;
  hasResult: boolean;
  /** The tool already has its own Copy / Download buttons, so no generic bar. */
  ownActions: boolean;
  paid: boolean;
  gate: ((moment?: import("@/hooks/usePaywallDialog").PaywallMoment) => Promise<boolean>) | null;
}

const IDLE: ResultGateState = { active: false, hasResult: false, ownActions: false, paid: false, gate: null };
let state: ResultGateState = IDLE;
const listeners = new Set<() => void>();

export function setResultGate(next: ResultGateState) {
  if (
    state.active === next.active && state.hasResult === next.hasResult && state.ownActions === next.ownActions &&
    state.paid === next.paid && state.gate === next.gate
  ) return;
  state = next;
  listeners.forEach((l) => l());
}

export function clearResultGate() {
  setResultGate(IDLE);
}

export function useResultGate(): ResultGateState {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => state,
    () => IDLE,
  );
}
